
/* injects from baggage-loader */

'use strict';

import returnComponentTemplate from '!!file-loader?name=templates/[name].[ext]!./returnComponent.html';

/**
 * Function that register the all routes for the authentication module.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @param {any} routerHelper
 */
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	 * Route definition of the management return components Component page.
	 */
	const indexNav = 6;
	const indexSubmenu = 2;
	const returnComponentRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: returnComponentTemplate ,
			controller: 'ReturnComponentController',
			controllerAs: 'returncomponentvm',
			resolve: {
				returnComponent: returnComponentLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	};


	routerHelper.configureStates([returnComponentRoute]);
}

/**
 * Function for the lazyLoading configuration in the authentication route.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @returns
 */
function returnComponentLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const returnModule = require('./returnComponent.module');

		$ocLazyLoad.load({
			name: returnModule.default.name,
		});

		deferred.resolve(returnModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('returnComponent.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/returnComponent/returnComponent.route.js